export const SideBar = {
  getIsOpen() {
    return localStorage.getItem('openSideBar') === 'true';
  },
  setIsOpen(open: boolean) {
    localStorage.setItem('openSideBar', String(open));
  }
};
